<template>
  <div class="opc-layout" id="the-main-content">
    <div class="opc-layout__main" role="main">
      <div class="opc-layout__main__inner">
        <template v-if="globalErrorState"><error-config /></template>
        <template v-else><slot></slot></template>
      </div>
    </div>
    <div class="opc-layout__side" role="complementary">
      <template v-if="globalErrorState"><error-cart /></template>
      <template v-else><slot name="side"></slot></template>
    </div>
  </div>
</template>

<script>
import ErrorConfig from '@/components/error/config';
import ErrorCart from '@/components/error/cart';
import { mapGetters } from 'vuex';
export default {
  components: { ErrorCart, ErrorConfig },
  props: {
    title: String,
  },
  computed: {
    ...mapGetters(["globalErrorState"])
  },
};
</script>

<style lang="scss" scoped>
$main-width: 60%;
$side-width: 40%;
$main-inner-width: 650px;

.opc-layout {
  margin: 0 auto;
  display: flex;
  flex-direction: row;

  &__main {
    flex: 1;

    &__inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100% - $side-width;
      min-width: $main-inner-width;
      @media screen and (max-width: 1024px) {
        min-width: 0px;
      }
      @media screen and (min-width: 1025px) and (max-width: 1366px) {
        min-width: 580px;
      }
      @media screen and (min-width: 1367px) {
        min-width: 650px;
      }
      padding: 64px 0;
      margin: 0 auto;
    }
  }

  &__side {
    position: relative;
    width: $side-width;
    background: #f7f7f8;
    ::v-deep .zm-skeleton {
      padding: 64px 60px 0;
    }
  }
}
</style>
